var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0526428 15.0833C0.0526428 6.79899 6.76837 0.083252 15.0526 0.083252H21.7226C30.0069 0.083252 36.7226 6.79898 36.7226 15.0833V19.9166C36.7226 28.2009 30.0069 34.9166 21.7226 34.9166H15.0526C6.76837 34.9166 0.0526428 28.2009 0.0526428 19.9166V15.0833Z",
    fill: "url(#paint0_linear_1061_6354)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7895 11.5624C21.7895 13.4468 20.3207 14.9166 18.5789 14.9166C16.8372 14.9166 15.3684 13.4468 15.3684 11.5624C15.3684 9.67808 16.8372 8.20825 18.5789 8.20825C20.3207 8.20825 21.7895 9.67808 21.7895 11.5624Z",
    stroke: "#402052",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 21.8541C26 22.7948 25.3719 23.8085 24.0121 24.6394C22.6695 25.4599 20.751 25.9999 18.579 25.9999C16.4069 25.9999 14.4884 25.4599 13.1458 24.6394C11.786 23.8085 11.1579 22.7948 11.1579 21.8541C11.1579 20.9133 11.786 19.8997 13.1458 19.0687C14.4884 18.2483 16.4069 17.7083 18.579 17.7083C20.751 17.7083 22.6695 18.2483 24.0121 19.0687C25.3719 19.8997 26 20.9133 26 21.8541Z",
    stroke: "#402052",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1061_6354",
    x1: 33.0816,
    y1: 26.623,
    x2: 0.0521446,
    y2: 26.6026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9001C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20F6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActive);
export default __webpack_public_path__ + "static/media/profile-active.fe3aab7fee0255c251004d8354ac7c72.svg";
export { ForwardRef as ReactComponent };